import React, { useState, useContext } from 'react'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import ExpandLessRoundedIcon from '@material-ui/icons/ExpandLessRounded'
import ClickOutside from '../Other/ClickOutside'
import { MenuItem, Button, styled, Box } from '@material-ui/core'
import { LocaleContext } from '../../contexts/LocaleProvider'

const CurrencyMenu = styled(Box)(({ theme }) => ({
  width: '100%',
  position: 'absolute',
  top: 54,
  left: 0,
  backgroundColor: theme.colors.white,
  maxHeight: 300,
  overflowY: 'auto',
  zIndex: 2,
  boxShadow: theme.shadows[5]
}))
const CurrencyButton = styled(Button)(({ theme }) => ({
  width: '100%',
  justifyContent: 'flex-start',
  borderTop: '1px solid ' + theme.colors.grey2,
  height: 54,
  padding: theme.spacing(1, 2)
}))

function CurrencyDropdown(props) {
  const localeContext = useContext(LocaleContext)
  const currencies = props.currencies || ['EUR', 'GBP', 'USD', 'AUD', 'HKD', 'JPY', 'PLN', 'CHF']
  const [open, setOpen] = useState(null)

  const handleClick = () => {
    setOpen(!open)
  }

  const handleClose = () => {
    setOpen(null)
  }

  const handleItemClick = (currency) => {
    handleClose()
    localeContext.setCurrency(currency)
  }

  return (
    <ClickOutside onClickOutside={handleClose}>
      <Box style={{ position: 'relative' }}>
        <CurrencyButton
          style={{ flex: '0 0 auto' }}
          aria-controls="dropdown"
          aria-haspopup="true"
          onClick={handleClick}
          startIcon={props.icon}
          endIcon={open ? <ExpandLessRoundedIcon /> : <ExpandMoreIcon />}
        >
          {props.labels
            ? props.labels[currencies.indexOf(localeContext.currency)]
            : localeContext.currency}
        </CurrencyButton>
        {open && (
          <CurrencyMenu>
            {currencies.map((currencyCode, i) => {
              return (
                <MenuItem
                  key={`currency-${currencyCode}`}
                  value={currencyCode}
                  onClick={() => handleItemClick(currencyCode)}
                >
                  {props.labels ? props.labels[i] : currencyCode}
                </MenuItem>
              )
            })}
          </CurrencyMenu>
        )}
      </Box>
    </ClickOutside>
  )
}

export default CurrencyDropdown
